(function () {
'use strict';

angular
    .module('riskSelfAssessmentReviewControllers')
    .directive('topRiskToReview', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            topRisk: '=',
            selectedTopRisk: '='
        },
        restrict: 'AE',
        templateUrl: require('./topRiskToReview.tpl.html'),
        controller: ['$scope', '$modal', '$rootScope', 'grcRiskService', 'riskSelfAssessmentReviewService',
            function ($scope, $modal, $rootScope, grcRiskService, riskSelfAssessmentReviewService) {

            // Toggle Edit View
            $scope.toggleEditView = function () {
                $scope.dirCtxt.showEditView = !$scope.dirCtxt.showEditView;

                if (!$scope.dirCtxt.showEditView) {
                    $scope.selectedTopRisk.RiskID = null;
                    return;
                }

                if ($scope.dirCtxt.showEditView) {
                    $scope.selectedTopRisk.RiskID = $scope.topRisk.Risk.RiskID;

                    riskSelfAssessmentReviewService
                          .getRiskToReview($scope.topRisk.Risk.RiskID)
                          .then(function (riskToReview) {
                              $scope.topRisk.PreviousAssessments = riskToReview.PreviousAssessments;
                          });

                    refreshKeyRisks();
                }
            };

            $scope.init = function () {
                $scope.dirCtxt = {
                    showEditView: false
                };
            };

            // Page is dirty
            $scope.pageIsDirty = function () {
                $scope.dirCtxt.needSaveChanges = true;
                $rootScope.$broadcast('page-is-dirty');
            }
            $scope.pageIsNotDirty = function () {
                $scope.dirCtxt.needSaveChanges = false;
                $rootScope.$broadcast('page-is-not-dirty');
            }

            $scope.onSelectedTopRiskChange = function (riskId) {
                if (_.isUndefined(riskId)) return;

                if (riskId !== $scope.topRisk.Risk.RiskID) $scope.dirCtxt.showEditView = false;
            };

            $scope.openFinalChangesConfirmationModal = function ($event) {
                $event.stopPropagation();

                // Modal to show
                var modalScope = $scope.$new(true);
                modalScope.topRisk = _.cloneDeep($scope.topRisk);

                var showModal = $modal({
                    scope: modalScope,
                    template: require('./finalChangesConfirmationModal.tpl.html'),
                    placement: 'center'
                });

                // Hide Modal
                modalScope.hideModal = function () {
                    showModal.$promise.then(showModal.hide);
                };

                // OK Modal
                modalScope.okModal = function () {
                    modalScope.hideModal();
                };

                // Pre Final Values Modified
                modalScope.preFinalModified = function () {
                    modalScope.showRatingChangedComment =
                        modalScope.topRisk.Assessment.FinalProbabilityCode   !== modalScope.topRisk.Assessment.PreFinalProbabilityCode
                        || modalScope.topRisk.Assessment.FinalSeverityCode   !== modalScope.topRisk.Assessment.PreFinalSeverityCode
                        || modalScope.topRisk.Assessment.FinalMitigationCode !== modalScope.topRisk.Assessment.PreFinalMitigationCode
                        || modalScope.topRisk.Assessment.FinalOverallCode    !== modalScope.topRisk.Assessment.PreFinalOverallCode;
                };

                // Confirm PreFinal Changes
                modalScope.confirmPreFinalChanges = function () {

                    return riskSelfAssessmentReviewService
                                .confirmPreFinalChangesOnRiskAssessment(modalScope.topRisk)
                                .then(function (topRiskToReview) {
                                    $scope.topRisk.Assessment = topRiskToReview.Assessment;
                                    $scope.pageIsNotDirty();

                                    return refreshKeyRisks()
                                           .then(function () {
                                               modalScope.hideModal();
                                           });
                                });
                };

                // Confirm Final Changes
                modalScope.confirmFinalChanges = function () {
                    if ($scope.showRatingChangedComment && !$scope.topRisk.Assessment.FinalOverrideExplanation) return;

                    $scope.dirCtxt.isLoading = true;

                    return riskSelfAssessmentReviewService
                                .reviewRiskByAssessor(modalScope.topRisk)
                                .then(function (riskToReview) {
                                    $scope.topRisk.Assessment = riskToReview.Assessment;
                                    modalScope.hideModal();
                                })
                                .finally(function () {
                                    $scope.dirCtxt.isLoading = false;
                                });
                };

                // Discard Changes
                modalScope.discardChanges = function () {

                    return riskSelfAssessmentReviewService
                                .discardPreFinalChangesOnRiskAssessment($scope.topRisk)
                                .then(function (topRiskToReview) {
                                    $scope.topRisk.Assessment = topRiskToReview.Assessment;
                                    $scope.pageIsNotDirty();

                                    return refreshKeyRisks()
                                           .then(function () {
                                               modalScope.hideModal();
                                           });
                                });
                };

                // Cancel Review
                modalScope.cancelReview = function () {

                    return riskSelfAssessmentReviewService
                                .resetFinalChangesOnRiskAssessment($scope.topRisk)
                                .then(function (topRiskToReview) {
                                    $scope.topRisk.Assessment = topRiskToReview.Assessment;
                                    $scope.pageIsNotDirty();
                                    modalScope.hideModal();
                                });
                };
            };

            $scope.refreshTopRiskAssessment = function () {
                return riskSelfAssessmentReviewService
                        .getRiskToReview($scope.topRisk.Risk.RiskID)
                        .then(function (riskToReview) {
                            $scope.topRisk.Assessment = riskToReview.Assessment;
                            $scope.pageIsDirty();
                        })
            };

            $scope.showPreFinalRatings = function () {
                return !$scope.topRisk.Assessment.HasFinalAssessorReviewed;
            };

            $scope.toggleShowPreviousAssessments = function () {
                $scope.dirCtxt.withPreviousAssessments = !$scope.dirCtxt.withPreviousAssessments;
            };

                // Set Pre Final Values
            $scope.setPreFinalValues = function () {
                $scope.topRisk.Assessment.PreFinalProbabilityCode = $scope.topRisk.Assessment.PreFinalProbabilityCode || $scope.topRisk.Assessment.InitialProbabilityCode;
                $scope.topRisk.Assessment.PreFinalMitigationCode = $scope.topRisk.Assessment.PreFinalMitigationCode || $scope.topRisk.Assessment.InitialMitigationCode;
                $scope.topRisk.Assessment.PreFinalSeverityCode = $scope.topRisk.Assessment.PreFinalSeverityCode || $scope.topRisk.Assessment.InitialSeverityCode;
                $scope.topRisk.Assessment.PreFinalOverallCode = $scope.topRisk.Assessment.PreFinalOverallCode || $scope.topRisk.Assessment.InitialOverallCode;
                $scope.topRisk.Assessment.PreFinalComputedOverallCode = $scope.topRisk.Assessment.PreFinalComputedOverallCode || $scope.topRisk.Assessment.InitialComputedOverallCode;
                $scope.topRisk.Assessment.PreFinalOverrideExplanation = $scope.topRisk.Assessment.PreFinalOverrideExplanation || $scope.topRisk.Assessment.InitialOverrideExplanationOverall;
                $scope.topRisk.Assessment.PreFinalIsOverriden = _.isBoolean($scope.topRisk.Assessment.PreFinalIsOverriden) ?
                                                                    $scope.topRisk.Assessment.PreFinalIsOverriden : $scope.topRisk.Assessment.InitialIsOverrideOverall;
            }

            function refreshKeyRisks() {
                return riskSelfAssessmentReviewService
                            .getKeyRisksToReviewByTopRisk($scope.topRisk.Risk.RiskID)
                            .then(function (keyRisksToReview) {
                                $scope.keyRisks = keyRisksToReview;

                                return keyRisksToReview;
                            });
            }
        }],
        link: function (scope, element, attrs) {
            scope.init();
            scope.$watch('selectedTopRisk.RiskID', scope.onSelectedTopRiskChange);

            scope.$watch('topRisk.Assessment', function (newValue) {
                if (!newValue) return;

                scope.setPreFinalValues();
            }, true);
        }
    };
}
})();
